const SearchData = {
    // Search
    form: {
        price_zone: '',

        //検索用カテゴリデータ
        categoriyLv1: [],
        categoriyLv2: [],
        categoriyLv3: [],

        //こだわり条件
        sales_recruitment_b: [],
        sales_recruitment_c: [],
        order: [],
        sales_style: [],
        pay_rule: [],
        //検索用エリアデータ
        areaLv1: [],
        areaLv2: [],
        areaLv3: [],
        target_max: '',
        target_min: '',
        net_shop: '',
        price_max: '',
        price_min: '',

        //ハッシュタグ
        hashtags: [],
        freeText:'',

        shop_user_plan: '',
    },

    //ブランドリスト画面、検索表示用
    set: {
        user: '',
        price_zone: [],
        third_categories: [],
        sales_recruitment: [],
        sales_style: [],
        order: [],
        pay_rule: [],
        area_region: [],
        hashtags: [],
        categories: [],
        areas: [],
        form: [],
        search_history: [],
        shop_user_plan: '',
    },

    res: []

}

export default SearchData
